import { render, staticRenderFns } from "./list-for-user.vue?vue&type=template&id=4a3ed060&scoped=true"
import script from "./list-for-user.vue?vue&type=script&lang=ts"
export * from "./list-for-user.vue?vue&type=script&lang=ts"
import style0 from "./list-for-user.vue?vue&type=style&index=0&id=4a3ed060&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3ed060",
  null
  
)

export default component.exports